import React, { useEffect, useState } from "react";
import moment from "moment";
import CTable from "../../UI/CTable";
import { getUserBalanceHistory } from "../../../utils/api";
import { getBalancePointsString } from "../../../helpers/prizes-shop";

import "./style.scss";

const className = "balance-history-modal";

const getActionType = (data) => {
    let actionType = data.action;

    if (actionType === 'manualChange') {
        const isDown = String(data.balanceDiff).startsWith("-");
        actionType += isDown ? "Down" : "Up";
    }

    return actionType;
}

const tableColumns = (getLocale) => [
    {
        field: 'date',
        displayName: getLocale('common.date&Time'),
        render: (row) => <span>{moment.unix(row.createdAt).format('DD.MM.YY HH:mm:ss')}</span>,
        width: '10rem'
    },
    {
        field: 'actionType',
        displayName: getLocale('common.actionType'),
        render: (row) => <span>{getLocale(`common.actionType.${getActionType(row)}`) || ''}</span>,
        minWidth: '10rem',
    },
    {
        field: 'balanceDiff',
        displayName: getLocale('common.added'),
        align: 'right',
        width: '4rem'
    },
    {
        field: 'balance',
        displayName: getLocale('shop.balance'),
        render: (row) => <b>{row.balance}</b>,
        align: 'right',
        width: '4rem'
    },
];

export default ({ event, $locale, userBalance }) => {
    const [data, setData] = useState([]);

    const getData = async () => {
        try {
            const _data = await getUserBalanceHistory(event.eventKey);
            setData(_data || []);
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getData();
    }, [])

    return <div className={className}>
        <div className={`${className}-title`}>{$locale.get('common.balanceHistory')}</div>
        <div className={`${className}-subtitle`}>
            {$locale.get('shop.balance')} {getBalancePointsString({$locale, price: userBalance})}
        </div>
        <CTable columns={tableColumns($locale.get)} data={data} />
    </div>
}